module.exports = __webpack_public_path__ + "static/1- speech therapy-756fff9d9defbda6da84773c9bb0b72b.png";